import React, { useEffect, useRef, useState } from "react";
import { Button, Dropdown, Form, Input, Modal, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import remove from "../../../assets/svg/delete.svg";
import svg37 from "../../../assets/svg/svg37.svg";
import svg25 from "../../../assets/svg/svg25.svg";
import {
  fetchManualSettlements,
  fetchOrganizationDrop,
} from "../../../features/fetch/fetchSlice";
import PhoneInput from "react-phone-input-2";

const { TextArea } = Input;
const FilterModal = ({
  isModalOpen,
  handleCancel,
  prodd,
  formData,
  setFormData,
  filters,
  setFilters,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { orgDrop } = useSelector((state) => state.fetch);

  const items = [
    {
      label: "Account Number",
      key: "Account Number",
    },
    {
      label: "Phone Number",
      key: "Phone Number",
    },
    {
      label: "Organization Name",
      key: "Organization Name",
    },
  ];

  // const [filters, setFilters] = useState([]);

  const filteredItems = items.filter(
    (item) => !filters?.some((filter) => filter?.value === item?.key)
  );

  const settingItems = filteredItems?.map((item) => ({
    key: item?.key,
    label: (
      <div
        className="font-dmSans text-black font-[400] text-[19px] mt-[5%]"
        onClick={() => handleMenuItemClick(item?.key)}
      >
        {item?.label}
      </div>
    ),
  }));

  const handleMenuItemClick = (itemKey) => {
    if (itemKey === "Account Number") {
      const newFilter = {
        type: "Account Number",
        value: "Account Number",
      };
      setFilters([...filters, newFilter]);
    } else if (itemKey === "Phone Number") {
      const newFilter = {
        type: "Phone Number",
        value: "Phone Number",
      };
      setFilters([...filters, newFilter]);
    } else if (itemKey === "Organization Name") {
      const newFilter = {
        type: "Organization Name",
        value: "Organization Name",
      };
      setFilters([...filters, newFilter]);
    }
  };

  const removeFilter = (index) => {
    const updatedFilters = filters?.filter((_, idx) => idx !== index);
    setFilters(updatedFilters);
    setFormData((prevData) => {
      const updatedData = { ...prevData };
      if (filters[index].type === "Account Number") {
        delete updatedData.manualPaymentBeneficiaryAccount;
      } else if (filters[index].type === "Phone Number") {
        delete updatedData.manualPaymentReceiverMobileNo;
      } else if (filters[index].type === "Organization Name") {
        delete updatedData.manualPaymentOrgId;
      }
      return updatedData;
    });
  };

  // const [formData, setFormData] = useState();

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  function handleSelectChange(value, formName) {
    setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const handleNumberChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      manualPaymentReceiverMobileNo: String(e),
    }));
  };

  const onFinish = async (data) => {
    const res = await dispatch(
      fetchManualSettlements({
        url: "api/v2/manualPayment/getManualPayments",
        manualPaymentOrgId: formData?.manualPaymentOrgId,
        manualPaymentReceiverMobileNo: formData?.manualPaymentReceiverMobileNo,
        manualPaymentBeneficiaryAccount:formData?.manualPaymentBeneficiaryAccount,
      })
    );
    if (res?.payload?.success) {
      // toast.success(res.payload?.messages?.message);
      handleCancel();
    } else {
      toast.error(res.payload?.messages?.message);
    }
  };

  const handleClear = async () => {
    await setFilters([]);
    await setFormData({});
    await handleCancel();
  };

  async function fetchOrganizationDropData() {
    await dispatch(
      fetchOrganizationDrop({
        url: "api/v1/admin/get-dynamicOrganisations",
        orgStatus: "APPROVED",
      })
    );
  }
  useEffect(() => {
    fetchOrganizationDropData();
  }, []);

  return (
    <>
      <Modal
        className="!mt-[13%] filter-modal "
        title="New Account "
        open={isModalOpen}
        onCancel={handleCancel}
        width={800}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className="px-[15px]"
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="flex justify-between text-black21 text-[18px] font-normal leading-[24px] font-dmSans mb-5">
            <div className="">Filters</div>
            <div className="cursor-pointer" onClick={handleClear}>
              Clear
            </div>
          </div>
          <div className="grid grid-cols-1">
            <span className="text-black21 text-[18px] font-normal leading-[24px] font-dmSans mt-5">
              All filters
            </span>
            {filters?.map((filter, index) => (
              <div
                key={index}
                className="flex flex-col items-start mt-4 w-full"
              >
                {filter.type === "Account Number" && (
                  <div className="flex items-center w-full gap-x-2">
                    <Form.Item className="w-[100%]">
                      <Input
                        className="input"
                        name={`input-${index}`}
                        value={filter.value}
                        readOnly={true}
                      />
                    </Form.Item>
                    <Form.Item className="w-[100%]">
                      <Input
                        name="manualPaymentBeneficiaryAccount"
                        className="input"
                        onChange={onChange}
                        value={formData?.manualPaymentBeneficiaryAccount}
                        placeholder="Enter Account number."
                      />
                    </Form.Item>
                    <Form.Item className="w-[20%]">
                      <button onClick={() => removeFilter(index)}>
                        <img src={remove} alt="remove-icon" />
                      </button>
                    </Form.Item>
                  </div>
                )}
                {filter.type === "Phone Number" && (
                  <div className="flex items-center w-full gap-x-2">
                    <Form.Item className="w-[100%]">
                      <Input
                        className="input"
                        name={`input-${index}`}
                        value={filter.value}
                        readOnly={true}
                      />
                    </Form.Item>
                    <Form.Item className="w-[100%]">
                      <PhoneInput
                        name="manualPaymentReceiverMobileNo"
                        value={formData?.manualPaymentReceiverMobileNo}
                        onChange={handleNumberChange}
                        country="ke"
                        onlyCountries={["ke"]}
                        countryCodeEditable={false}
                        className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
                      />
                    </Form.Item>
                    <Form.Item className="w-[20%]">
                      <button onClick={() => removeFilter(index)}>
                        <img src={remove} alt="remove-icon" />
                      </button>
                    </Form.Item>
                  </div>
                )}

                {filter.type === "Organization Name" && (
                  <div className="flex items-center w-full gap-x-2">
                    <Form.Item className="w-[100%]">
                      <Input
                        className="input"
                        name={`input-${index}`}
                        value={filter.value}
                        readOnly={true}
                      />
                    </Form.Item>
                    <Form.Item className="w-[100%]">
                      <Select
                        name="manualPaymentOrgId"
                        value={formData?.manualPaymentOrgId}
                        className=""
                        allowClear
                        placeholder="Select organization"
                        style={{
                          width: "100%",
                        }}
                        onChange={(value) => {
                          handleSelectChange(value, "manualPaymentOrgId");
                        }}
                        options={
                          orgDrop?.length > 0 &&
                          orgDrop?.map((item) => ({
                            value: item?.orgId,
                            label: item?.orgName,
                          }))
                        }
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label?.toLocaleLowerCase() ?? "").includes(
                            input?.toLocaleLowerCase()
                          )
                        }
                        onDropdownVisibleChange={() => {}}
                      />
                    </Form.Item>
                    <Form.Item className="w-[20%]">
                      <button onClick={() => removeFilter(index)}>
                        <img src={remove} alt="remove-icon" />
                      </button>
                    </Form.Item>
                  </div>
                )}
              </div>
            ))}

            <div className="flex justify-between items-center">
              <Dropdown
                overlayStyle={{
                  width: "200px",
                }}
                trigger={"click"}
                menu={{ items: settingItems }}
                placement="bottom"
              >
                <Button
                  type="btn"
                  className="flex items-center w-[150px] bg-[#A3A2A7] text-white h-[45px] py-3 px-2
                 rounded-[10px] gap-x-1 mb-10 mt-5 !text-lexendS text-[16px] font-[500]"
                >
                  <img src={svg25} alt="add-icon" />
                  Add Filter
                  <img src={svg37} alt="svg37" />
                </Button>
              </Dropdown>

              {filters && filters?.length > 0 && (
                <div className="w-[150px]">
                  <button type="submit" className="cstm-btn-2">
                    submit
                  </button>
                </div>
              )}
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default FilterModal;
